import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';

@Component({
    selector: 'app-loading',
    imports: [CommonModule],
    templateUrl: './loading.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LoadingComponent {
    @Input() text?: string;
}
